export default {
    "WISHLIST": {
        "WISHLIST": "Wishlist",
        "WISHLISTS": "Wishlists",
        "CATEGORY": "Category",
        "CATEGORIES": "Categories",
        "NAME": "Name",
        "ACTIVE": "Active",
        "PURCHASE": "Purchase",
        "SCANCODE": "Scancode",
        "REFERRER": "Referrer",
        "FILLEDOUT": "Done",
        "SUM": "{sum} matches",
        "PURCHASED_AT": "Purchased at",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/en/wishlist.js